import { Flex } from "@chakra-ui/react";
import "./loadingPage.css";
import Logo from "../../Layout/Logo.tsx";

export const LoadingPage = ({
  isFullPage = false,
}: {
  isFullPage?: boolean;
}) => {
  return (
    <Flex
      flexDirection={"column"}
      justifyContent={"space-evenly"}
      style={{
        flex: 1,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999,
        height: "95hv",
      }}
      bg={"bg.muted"}
    >
      {isFullPage && (
        <Flex pt={6} justifyContent={"center"} w={"100%"}>
          <Logo />
        </Flex>
      )}
      <Flex
        justifyContent={"center"}
        alignItems={"center"}
        height={"80vh"}
        flexDirection={"column"}
      >
        <div className={"loader"} />
      </Flex>
    </Flex>
  );
};
